import { Voucher_Type } from "./VoucherServices";

// export enum VoucherType {
//     All,
//     SalesVoucher,
//     CreditNote,
//     PurchaseVoucher,
//     DebitNote,
//     Payment,
//     Receipt,
//     Contra,
//     PurchaseOrder,
//     SalesOrder,
//     Journal,
// }

interface Client {
    id: string;
}

export const viewVoucher = (
    id: string,
    voucherType: Voucher_Type,
    setId: (id: string) => void,
    setIsOpen: (isOpen: boolean) => void,
    setPaymentId: (id: string) => void,
    setType: (type: Voucher_Type) => void,
    setExpIncModalOpen:(isOpen:boolean)=> void,
    setInvoiceModel: (model: string) => void,
    setJournalModal: (isOpen: boolean) => void,
) => {
    setId(id);
    setType(voucherType);

    switch (voucherType) {
        case Voucher_Type.Receipt:
            case Voucher_Type.Payment:
                case Voucher_Type.Contra:
            setIsOpen(true);
            setPaymentId(id);
            setType(voucherType); break;
            case Voucher_Type.Expenses:
                case Voucher_Type.Income:
                setExpIncModalOpen(true)
            setPaymentId(id);
            setType(voucherType); break;
        case Voucher_Type.SalesVoucher:
            setInvoiceModel("viewSalesInvoice");
            setPaymentId(id);
            break;
        case Voucher_Type.PurchaseVoucher:
            case Voucher_Type.CreditNote:
            case Voucher_Type.DebitNote:
            setInvoiceModel("viewPurchaseBill");
            setPaymentId(id);
            break;
        case Voucher_Type.Journal:
            setJournalModal(true);
            setPaymentId(id);
            break;
        default:
            setId(id);
    }
};
